import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/identity_analytics.py
export const IDENTITY_ANALYTICS_ACTIONS = {
  OPENED_MODAL_EFFECTIVE_PERMISSIONS: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'opened_modal_effective_permissions',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLOSED_MODAL_EFFECTIVE_PERMISSIONS: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'closed_modal_effective_permissions',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_DATA_ACCESS_ROW_OVERFLOW_MENU: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'opened_data_access_row_overflow_menu',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_PARTY_BASIC_SETTINGS_TAB: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'opened_party_basic_settings_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_PARTY_DATA_ACCESS_TAB: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'opened_party_data_access_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_PARTY_SETTINGS: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'clicked_party_settings',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
